import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FC, ReactNode, useCallback } from 'react'

export interface ModalDefaultProps {
  children?: ReactNode
  title?: ReactNode
  isOpen: boolean
  sideModal?: boolean
  modalClassName?: string
  className?: string
  onDismiss: () => void
  toggle: () => void
  size?: 'sm' | 'md' | 'lg' | 'xl'
  onBeforeClose?: () => Promise<boolean>
  preventDismiss?: boolean
}

const ModalDefault: FC<ModalDefaultProps> = ({
  children,
  className,
  isOpen,
  modalClassName,
  onBeforeClose,
  onDismiss,
  preventDismiss = false,
  sideModal,
  size,
  title,
  toggle,
}) => {
  const handleToggle = useCallback(async () => {
    if (preventDismiss) return

    if (onBeforeClose) {
      let shouldClose = false
      try {
        shouldClose = await onBeforeClose()
      } catch (err) {
        console.error('onBeforeClose threw:', err)
        shouldClose = false
      }
      if (!shouldClose) return
    }

    onDismiss()
    toggle()
  }, [preventDismiss, onBeforeClose, onDismiss, toggle])

  return (
    <Modal
      isOpen={isOpen}
      size={size}
      unmountOnClose
      backdrop={preventDismiss ? 'static' : true}
      keyboard={!preventDismiss}
      modalClassName={sideModal ? 'side-modal' : modalClassName}
      toggle={handleToggle}
    >
      {!!title && (
        <ModalHeader toggle={!preventDismiss ? handleToggle : undefined}>
          {title}
        </ModalHeader>
      )}
      <ModalBody className={className}>{children}</ModalBody>
    </Modal>
  )
}

export default ModalDefault
